module.exports = __webpack_public_path__ + "img/3.5ea422ed.jpg";